import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

// Standalone personal notifications page, reached from the Header dropdown.
// Placeholder for now: the app only has transient toast notifications today
// (see src/actions/notificationActions.js) — there is no persisted inbox.
// A real inbox needs a backend list/mark-read endpoint plus a
// notifications.service.js; tracked as follow-up work.
const AccountNotifications = () => (
  <div className="container-fluid">
    <Row className="mt-4">
      <Col xs={12} md={12}>
        <Row className="align-contents-center">
          <Col xs={12} md={6}>
            <h4>Notifications</h4>
            <p className="category">Personal alerts and updates</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div
                  className="text-center text-muted"
                  style={{ padding: '40px 0' }}
                >
                  <i
                    className="now-ui-icons ui-1_bell-53"
                    style={{
                      fontSize: '40px',
                      display: 'block',
                      marginBottom: '12px',
                    }}
                  />
                  <p>You have no notifications yet.</p>
                  <p className="category">
                    A personal notifications inbox is coming soon.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
);

export default AccountNotifications;
